import React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Header from "src/components/wizard/Header";
import Footer from "src/components/wizard/Footer/Footer";
import { fullWidthDialog } from "src/constants/dialog";

export default function WizardStepDialog({ open, title, onClose, step, steps, children, actions }) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose} sx={fullWidthDialog}>
      <Box display="flex" flexDirection="column" minHeight={460}>
        <Header title={title} onClose={onClose} />
        <DialogContent sx={{ px: 3, py: 2, flexGrow: 1 }}>{children}</DialogContent>
        <Footer step={step} steps={steps} showRaceMode={false}>
          {actions}
        </Footer>
      </Box>
    </Dialog>
  );
}
